import { useSyncExternalStore } from "react";
import type { StaffTag } from "@/features/auth/api/auth-staff";
import {
	canWorkRequests,
	getSession,
	hasStaffTag,
	isPortalAdmin,
	isAuthenticated as readIsAuthenticated,
	subscribeAuth,
} from "@/features/auth/lib/auth-store";

/** Re-render when session changes (login / logout / hydrate). */
export function useAuth() {
	const session = useSyncExternalStore(subscribeAuth, getSession, () => null);
	return {
		session,
		isAuthenticated: Boolean(session?.accessToken && session?.refreshToken),
		isPortalAdmin: session ? isPortalAdmin() : false,
		canWorkRequests: session ? canWorkRequests() : false,
		hasTag: (tag: StaffTag) => hasStaffTag(tag),
	};
}

export function useIsAuthenticated(): boolean {
	return useSyncExternalStore(subscribeAuth, readIsAuthenticated, () => false);
}
